import { Directive, Input, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appDateRangeValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateRangeValidatorDirective),
      multi: true
    }
  ]
})
export class DateRangeValidatorDirective implements Validator {

  constructor() { }

  @Input() dateRange!: { startDate: string, endDate: string };

  validate(control: AbstractControl): ValidationErrors | null {

    if (this.dateRange) {
      console.log("dateRange", this.dateRange);
      const startDateControl = control.get(this.dateRange.startDate);
      console.log('startDateControl', startDateControl);
      const endDateControl = control.get(this.dateRange.endDate);

      if (!startDateControl || !endDateControl) {
        return null;
      }
      const startDate = new Date(startDateControl.value);
      const endDate = new Date(endDateControl.value);
      if (startDate && endDate && startDate > endDate) {
        return { dateRangeInvalid: true };
      }
      return null;
    }

    else {
      return null;
    }
  }

}
